module.exports = __webpack_public_path__ + "static/img/asphaltSketch@2x.ca1d54b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/asphaltSketch@2x.png
// module id = N5qy
// module chunks = 1